// Helpers for the listing / buyer file request form's validation.
//
// Two problems this exists to fix:
//
// 1. The client check looped over the contact rows, so a form with NO rows ran
//    no checks at all and a request could go through with nobody attached.
// 2. A failed validation set inline field errors and returned silently. If the
//    offending field was scrolled out of view, pressing Submit looked like it
//    did nothing at all.

// Plain-language names for the internal error keys, so the message a user reads
// matches the label they see on the form.
const FIELD_LABELS = {
  agentName: "Agent",
  leadsource: "Lead source",
  fileFormat: "File format",
  formType: "Form type",
  propertyAddress: "Property address",
  propertyTrust: "Property trust",
  preListing: "Pre-listing drop off",
  referredSendGift: "Who referred & send gift",
  clientErrors: "Client",
};

// True when the form has no usable contact: no rows at all, or only rows that
// were never filled in. One real contact anywhere is enough.
export function hasNoClient(clientIds) {
  return !(clientIds || []).some((id) => id && String(id).trim() !== "");
}

// Turns the internal errors object into a list of human field names, for the
// "Missing: ..." message. Client rows collapse to a single "Client" entry
// rather than leaking the per-row error shape at the user.
export function describeMissing(errors) {
  return Object.entries(errors || {}).reduce((missing, [key, value]) => {
    if (key === "clientErrors") {
      const anyClientError = (value || []).some(
        (row) => row && Object.keys(row).length > 0,
      );
      if (anyClientError) missing.push(FIELD_LABELS.clientErrors);
      return missing;
    }
    missing.push(FIELD_LABELS[key] || key);
    return missing;
  }, []);
}
